module.exports = __webpack_public_path__ + "static/media/bloodThinner.856841b5.mp3";